import { gql } from 'apollo-boost'

const HTML_MENU_SCRAPING_SCREENSHOT_URL = gql`
  query htmlMenuScrapingScreenshotUrl($bucketName: String!, $fileKey: String!) {
    htmlMenuScrapingScreenshotUrl(bucketName: $bucketName, fileKey: $fileKey)
  }
`

export default HTML_MENU_SCRAPING_SCREENSHOT_URL
